export default "__VITE_ASSET__DdsDufuj__"